import { Pipe, PipeTransform } from "@angular/core";
import { TriggerDto } from "@api";
import { TranslateService } from "@ngx-translate/core";

@Pipe({ name: "translateTriggerNames" })
export class TranslateTriggerNamesPipe implements PipeTransform {
  constructor(private i18n: TranslateService) {}

  public transform(triggers: TriggerDto[]): TriggerDto[] {
    return triggers
      .map(trigger => ({ ...trigger, name: this.i18n.instant(`TRIGGERS.${trigger.name}`) }))
      .filter(trigger => trigger.type !== TriggerDto.TypeEnum.Scenario);
  }
}
